const SYSTEM_FONT_PREFIX = 'system-';

export function systemFontId(family: string): string {
  const safeName = family.trim().replace(/[^A-Za-z0-9_-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 110);
  return `${SYSTEM_FONT_PREFIX}${safeName || 'sans-serif'}`;
}

export function systemFontFamily(fontId: string): string | null {
  if (!fontId.startsWith(SYSTEM_FONT_PREFIX)) return null;
  return fontId.slice(SYSTEM_FONT_PREFIX.length).replace(/_/g, ' ');
}
